/* global serverParams */

const { guff } = require('bam-node-baseball-savant/utils/guff')

const isPitcher = serverParams.type === 'pitcher'

function getLeftHeaders(showInactives, isTodayTable) {
    const headers = [
        {
            name: 'Player',
            field: 'player_name',
            headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
            fieldClass: `tr-data align-left table-static-column`,
            defaultSortDir: 'asc',
            displayFn: (val, { id }) => {
                const imageHtml = `
                    <img
                        class="player-mug"
                        height="60"
                        width="60"
                        onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';"
                        src="https://content.mlb.com/images/headshots/current/60x60/${id}.png"
                    />
                `
                return `${imageHtml} <a href="/savant-player/${id}" target="_blank">${val}</a>`
            },
        },
        {
            name: 'Active',
            field: 'is_player_active',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'asc',
            displayFn: (val) => {
                const yesNo = val === 1 ? 'Yes' : 'No'
                return `<span${
                    showInactives && val === 1 ? ' style="color: red"' : ''
                }>${yesNo}</span>`
            },
        },
        {
            name: 'Birthday',
            field: 'birth_day_noyear_sort_hidden',
            headerClass: `th-component-header align-center th-vertical-bottom border-left`,
            fieldClass: `tr-data align-center border-left`,
            defaultSortDir: 'asc',
            displayFn: (val, { isBirthday, dateString }) => {
                if (isBirthday && !isTodayTable) {
                    return `&#127856;  <span style="color: red">${dateString}</span>  &#127856;`
                }
                return dateString
            },
        },
        {
            name: 'Age',
            field: 'age',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'asc',
            displayFn: (val, { isBirthday, is_player_deceased }) => {
                if (is_player_deceased) {
                    return '--'
                }
                if (isBirthday && !isTodayTable) {
                    return `<div style="color: red">${val}</div>`
                }
                return val
            },
        },
    ]

    if (!isTodayTable) {
        headers.push({
            name: 'Days<br />Until',
            field: 'daysUntil',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'asc',
            displayFn: (val, { isBirthday }) => {
                const zeroedOutVal = val === 0 ? '--' : val
                if (isBirthday) {
                    return `<div style="color: red">${zeroedOutVal}</div>`
                }
                return zeroedOutVal
            },
        })
    }

    headers.push(
        {
            name: 'B-Day<br />Index',
            field: 'birthday_index',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom border-left`,
            fieldClass: `tr-data align-center border-left`,
            defaultSortDir: 'desc',
            highlight: [-6, 0, 6],
            displayFn: (val) => guff(val, 'run_value_zone'),
        },
        {
            name: 'G',
            field: 'birthday_games',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom border-left`,
            fieldClass: `tr-data align-center border-left`,
            defaultSortDir: 'desc',
        },
        {
            name: 'PA',
            field: 'birthday_pa',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom dotted-right`,
            fieldClass: `tr-data align-center dotted-right`,
            defaultSortDir: 'desc',
        }
    )

    return headers
}

function getRightHeaders() {
    return [
        {
            name: 'B-Day<br />BA',
            field: 'birthday_BA',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom border-left`,
            fieldClass: `tr-data align-center border-left`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'ba'),
        },
        {
            name: 'Other<br />BA',
            field: 'non_birthday_BA',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'ba'),
        },
        {
            name: '+/-<br />BA',
            field: 'birthday_BA_diff',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'ba', { isDiff: true }),
            highlight: isPitcher ? [0.4, 0, -0.4] : [-0.4, 0, 0.4],
        },
        {
            name: 'B-Day<br />OPS',
            field: 'birthday_OPS',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom border-left`,
            fieldClass: `tr-data align-center border-left`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'ops'),
        },
        {
            name: 'Other<br />OPS',
            field: 'non_birthday_OPS',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'ops'),
        },
        {
            name: '+/-<br />OPS',
            field: 'birthday_OPS_diff',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'ops', { isDiff: true }),
            highlight: isPitcher ? [1.0, 0, -1.0] : [-1.0, 0, 1.0],
        },
        {
            name: 'B-Day<br />wOBA',
            field: 'birthday_wOBA',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom border-left`,
            fieldClass: `tr-data align-center border-left`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'woba'),
        },
        {
            name: 'Other<br />wOBA',
            field: 'non_birthday_wOBA',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'woba'),
        },
        {
            name: '+/-<br />wOBA',
            field: 'birthday_wOBA_diff',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'woba', { isDiff: true }),
            highlight: isPitcher ? [0.4, 0, -0.4] : [-0.4, 0, 0.4],
        },
    ]
}

function getHitterHeaders() {
    return [
        {
            name: 'Hits',
            field: 'birthday_hits',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
        {
            name: '1B',
            field: 'birthday_hit_1b',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
        {
            name: '2B',
            field: 'birthday_hit_2b',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
        {
            name: '3B',
            field: 'birthday_hit_3b',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
        {
            name: 'HR',
            field: 'birthday_hit_hr',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
    ]
}

function getPitcherHeaders() {
    return [
        {
            name: 'Hits',
            field: 'birthday_hits',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
        {
            name: 'K',
            field: 'birthday_strikeout',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
        {
            name: 'K%',
            field: 'birthday_k_percent',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'k_percent'),
        },
        {
            name: 'BB',
            field: 'birthday_walk',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
        },
        {
            name: 'BB%',
            field: 'birthday_bb_percent',
            type: 'number',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'bb_percent'),
        },
    ]
}

function getMiddleHeaders(isPitcherType) {
    if (isPitcherType) {
        return getPitcherHeaders()
    }
    return getHitterHeaders()
}

function getBirthdayHeaders(showInactives) {
    return [
        ...getLeftHeaders(showInactives, false),
        ...getMiddleHeaders(isPitcher),
        ...getRightHeaders(),
    ]
}

const secondaryHeaders = [
    {
        name: '',
        colspan: 3,
        headerClass: 'th-name-header',
    },
    {
        name: 'Birthday Info',
        colspan: 4,
        headerClass: 'th-title-header border-left',
    },
    {
        name: 'Birthday Stats',
        colspan: 7,
        headerClass: 'th-title-header border-left',
    },
    {
        name: 'Birthday Difference',
        colspan: 9,
        headerClass: 'th-title-header border-left',
    },
]

function getTodayHeaders(isPitcherBool) {
    return [...getLeftHeaders(true, true), ...getMiddleHeaders(isPitcherBool)]
}

module.exports = {
    getTodayHeaders,
    getBirthdayHeaders,
    secondaryHeaders,
}
